// These match container.type from API
export var AssetContainerType = {
  HTML: 'html',
  IMAGE: 'image',
  SLIDER: 'slider'
};